import { NdeipiTokenDenomination } from "../types/ndeipiTokenDenomination";


export function convertToBaseToken(amount: number, denomination: NdeipiTokenDenomination): string {
    const conversionFactors = {
        'zviri': 1 / 1000000,
        'vibes': 1 / 10000,
        'nzou': 1 / 1000,
        'shanga': 1 / 100,
        'ndeipi': 1 // Base token, no conversion needed
    };
    
    if (!(denomination in conversionFactors)) {
        throw new Error(`Invalid denomination: ${denomination}`);
    }
    
    const baseTokenAmount = amount * conversionFactors[denomination];
    
    // Format the number to avoid scientific notation for very small numbers
    return baseTokenAmount.toFixed(20).replace(/\.?0+$/, '');
}

export function convertFromBaseToken(amount: string, denomination: NdeipiTokenDenomination): number {
    const conversionFactors = {
        'zviri': 1000000,
        'vibes': 10000,
        'nzou': 1000,
        'shanga': 100,
        'ndeipi': 1
    };
    
    if (!(denomination in conversionFactors)) {
        throw new Error(`Invalid denomination: ${denomination}`);
    }
    
    const baseTokenAmount = parseFloat(amount);
    if (isNaN(baseTokenAmount)) {
        throw new Error(`Invalid amount: ${amount}`);
    }
    
    return baseTokenAmount * conversionFactors[denomination];
}